import actionTypes from "../common/actionTypes";
// constants
import { DATABASE_STATUTES } from "../common/constants";

const automationTagsReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_AUTOMATION_TAGS:
      return {
        ...state,
        status: DATABASE_STATUTES.LOADING,
      };

    case actionTypes.FETCH_AUTOMATION_TAGS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.FETCH_AUTOMATION_TAGS_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };
    // search
    case actionTypes.SEARCH_TAGS:
      return {
        ...state,
        status: DATABASE_STATUTES.LOADING,
      };

    case actionTypes.SEARCH_TAGS_SUCCESS:
      return {
        ...state,
        filteredData: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.SEARCH_TAGS_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    default:
      return state;
  }
};

export default automationTagsReducer;
